'use client'

import PropTypes from 'prop-types'
import { useDashboardVideoStore } from '@repo/store/useDashboardVideoStore'
import { Modal } from '@repo/ui/Modal'

export const DashboardVideoModal = ({ open_DI }) => {
  const { toggleVideoModal, open } = useDashboardVideoStore()

  return (
    <div data-testid="DashboardVideoModal">
      <Modal
        open={open_DI || open}
        handleClose={() => toggleVideoModal(false)}
        title={`What's new`}
        sx={{ height: '522px' }}
      >
        <iframe
          width="100%"
          height="420px"
          src={
            import.meta.env.VITE_SPA_OSPREY_DASHBOARD_VIDEO ||
            'https://www.youtube.com/embed/poowdWbQCcY?si=IpodFRGIVp4dBLcO'
          }
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </Modal>
    </div>
  )
}

DashboardVideoModal.propTypes = {
  open_DI: PropTypes.bool
}
